import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { loadFont as loadSerif } from "@remotion/google-fonts/PlayfairDisplay";
import { loadFont as loadScript } from "@remotion/google-fonts/DancingScript";
import { loadFont as loadMono } from "@remotion/google-fonts/JetBrainsMono";
import { SUBBRAND } from "../../../brand/theme";

const { fontFamily: serif } = loadSerif("normal", { weights: ["600", "700"] });
loadSerif("italic", { weights: ["500"] }); // register italic faces
const { fontFamily: script } = loadScript("normal", { weights: ["700"] });
const { fontFamily: mono } = loadMono("normal", { weights: ["500", "700"] });

const W = SUBBRAND.women;

export type VictoryWomenProps = {
  kicker: string;
  title: string;
  subtitle: string;
  datePlace: string;
};

export const VictoryWomen: React.FC<VictoryWomenProps> = ({ kicker, title, subtitle, datePlace }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const enter = spring({ frame, fps, config: { damping: 200 } });
  const rise = interpolate(enter, [0, 1], [26, 0]);
  const op = (a: number, b: number) => interpolate(frame, [a, b], [0, 1], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill
      style={{
        background: `linear-gradient(180deg, ${W.sky[0]} 0%, ${W.sky[1]} 55%, ${W.sky[2]} 100%)`,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* soft gold + light glows (watercolor approximation) */}
      <AbsoluteFill style={{ background: `radial-gradient(circle at 15% 12%, ${W.gold}33 0%, transparent 38%)` }} />
      <AbsoluteFill style={{ background: `radial-gradient(circle at 88% 90%, #FFFFFF66 0%, transparent 40%)` }} />

      <div style={{ textAlign: "center", transform: `translateY(${rise}px)`, padding: 120 }}>
        {/* lockup (placeholder for real cursive "Victory" logo) */}
        <div style={{ opacity: op(0, 18), marginBottom: 54 }}>
          <span style={{ fontFamily: script, fontSize: 64, color: W.skyText, fontWeight: 700 }}>Victory</span>
          <span style={{ fontFamily: mono, fontSize: 30, color: W.skyText, fontWeight: 700, letterSpacing: 10, marginLeft: 14 }}>WOMEN</span>
        </div>

        <div style={{ opacity: op(8, 26), fontFamily: mono, fontSize: 26, fontWeight: 500, letterSpacing: 6, color: W.skyText, marginBottom: 40 }}>
          {kicker}
        </div>

        <div style={{ opacity: op(14, 34), fontFamily: serif, fontSize: 132, fontWeight: 700, color: W.gold, lineHeight: 1.04, letterSpacing: 1 }}>
          {title}
        </div>

        <div style={{ opacity: op(22, 42), fontFamily: serif, fontStyle: "italic", fontSize: 48, fontWeight: 500, color: W.skyText, marginTop: 18 }}>
          {subtitle}
        </div>

        <div style={{ opacity: op(30, 50), fontFamily: mono, fontSize: 28, fontWeight: 500, letterSpacing: 4, color: W.skyText, marginTop: 64 }}>
          {datePlace}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
